export const getCountryByID = (data, id, defaultText) => {
    /**
     * busca y retorna el nombre de un pais en base a un id
     * 
     * params:
     * data => obj => datos de todos los paises disponibles
     * id => str => dato por el que se quiere filtrar 
     * defaultText => str => mensaje que se retorna en caso de que no se consiga el country
     * 
     * returns:
     *  aux => obj => nombre y id del pais filtrado 
     */
    if(id === null || !["string", "number"].includes(typeof(id))){
        return defaultText;
    }
    const IdN = parseInt(id, 10);
    const country = data.find((item) => item.id == IdN);
    if (!country){
        const countryLabel = data.find((item) => item.id == IdN);
        if(countryLabel){   
            return countryLabel.country;    
        }
        return defaultText;
    }

    const aux = country.country;
    
    return aux;
};

export const getNationality = (countries, nationalityValue, defaultText = "Not Available") => {
    /**
     * Función mejorada para manejar nacionalidad que puede ser código numérico o texto
     * 
     * params:
     * countries => array => lista de países disponibles
     * nationalityValue => string|number => valor de nacionalidad (puede ser código o texto)
     * defaultText => string => texto por defecto si no se encuentra
     * 
     * returns:
     * string => nombre del país o el texto original si es texto válido
     */
    
    // Si el valor es null, undefined o vacío
    if (!nationalityValue || nationalityValue === "") {
        return defaultText;
    }
    
    // Si es un número o string numérico, tratar como código de país
    if (!isNaN(nationalityValue) && nationalityValue !== "") {
        const countryId = parseInt(nationalityValue, 10);
        const country = countries.find((item) => item.id === countryId);
        if (country) {
            return country.country;
        }
        // Si no encuentra el país por ID, devolver el valor original
        return nationalityValue;
    }
    
    // Si es texto, verificar si coincide exactamente con algún país
    const exactMatch = countries.find((item) => 
        item.country.toLowerCase() === nationalityValue.toLowerCase()
    );
    if (exactMatch) {
        return exactMatch.country; // Devolver el nombre oficial del país
    }
    
    // Si es texto pero no coincide exactamente, buscar coincidencias parciales
    const partialMatch = countries.find((item) => 
        item.country.toLowerCase().includes(nationalityValue.toLowerCase()) ||
        nationalityValue.toLowerCase().includes(item.country.toLowerCase())
    );
    if (partialMatch) {
        return partialMatch.country; // Devolver el nombre oficial del país
    }
    
    // Si no encuentra coincidencias, devolver el texto original
    return nationalityValue;
};

/**
 * GUÍA DE USO PARA MANEJAR NACIONALIDADES
 * 
 * PROBLEMA: En la base de datos, el campo nationality puede contener:
 * 1. Códigos numéricos (IDs de países) - formato nuevo
 * 2. Texto libre (nombres de países) - formato antiguo
 * 
 * SOLUCIÓN: Usar la función getNationality() que maneja ambos casos
 * 
 * EJEMPLOS DE USO:
 * 
 * // Caso 1: Código numérico
 * getNationality(countries, "1") // Retorna: "Spain"
 * getNationality(countries, 1)   // Retorna: "Spain"
 * 
 * // Caso 2: Texto que coincide exactamente
 * getNationality(countries, "spain") // Retorna: "Spain" (nombre oficial)
 * getNationality(countries, "Spain") // Retorna: "Spain"
 * 
 * // Caso 3: Texto con coincidencia parcial
 * getNationality(countries, "united states") // Retorna: "United States"
 * getNationality(countries, "usa") // Retorna: "United States"
 * 
 * // Caso 4: Texto que no coincide
 * getNationality(countries, "País Inventado") // Retorna: "País Inventado"
 * 
 * // Caso 5: Valor vacío o null
 * getNationality(countries, "") // Retorna: "Not Available"
 * getNationality(countries, null) // Retorna: "Not Available"
 * 
 * IMPLEMENTACIÓN EN COMPONENTES:
 * 
 * 1. Importar la función:
 * import { getNationality } from "../util/getCountryById";
 * 
 * 2. Cargar los países en el estado:
 * state = { countries: [] }
 * 
 * 3. Crear método para cargar países:
 * loadCountries = async () => {
 *   const dataProvider = await dataProviderFactory("rest");
 *   const response = await dataProvider(GET_LIST, "countries", {
 *     pagination: { page: 1, perPage: 1000 },
 *     filter: {},
 *     sort: { field: "country", order: "ASC" },
 *   });
 *   this.setState({ countries: response.data });
 * };
 * 
 * 4. Llamar en componentDidMount:
 * async componentDidMount() {
 *   await this.loadCountries();
 * }
 * 
 * 5. Usar en el render:
 * <b>Nationality:</b> {getNationality(this.state.countries, data.nationality)}
 * 
 * COMPONENTES ACTUALIZADOS:
 * - tourBookingForm.js
 * - rentalBookingForm.js  
 * - tourClients.js
 * - mergeAccounts.js
 */


// WEBPACK FOOTER //
// ./src/util/getCountryById.js